module.exports = __webpack_public_path__ + "static/media/iStock-147087233.a3fdc024.jpg";